import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BackButton from "./BackButton";
import api from "../lib/api";
import { useContent } from "../lib/content";

function sessionId() {
  let sid = localStorage.getItem("sd_sid");
  if (!sid) {
    sid = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("sd_sid", sid);
  }
  return sid;
}

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const cms = useContent();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!pathname.startsWith("/admin")) {
      api.track({ path: pathname, sid: sessionId() }).catch(() => {});
    }
  }, [pathname]);

  return (
    <div className="grain-overlay relative min-h-screen bg-navy">
      <Navbar />
      <div data-testid="prelaunch-bar" className="fixed inset-x-0 top-[68px] z-40 border-y border-gold/20 bg-gold/10 backdrop-blur-md">
        <p className="mx-auto max-w-7xl px-5 py-2 text-center text-xs text-gold lg:px-8">
          {cms("site.prelaunch", "✦ Speed Détresse arrive bientôt — site en pré-lancement. Découvrez le projet et soyez informé de l'ouverture de l'application.")}
        </p>
      </div>
      <main className="relative z-10">{children}</main>
      <Footer />
      <BackButton />
    </div>
  );
}
